import type { LucideIcon } from "lucide-react";
import { Building2, LifeBuoy, ShieldCheck } from "lucide-react";

/** Super Admin Settings sections. Add an entry here to extend the secondary nav. */
export const SUPER_ADMIN_SETTINGS_SECTION_IDS = ["defaults", "support", "team"] as const;

export type SuperAdminSettingsSectionId = (typeof SUPER_ADMIN_SETTINGS_SECTION_IDS)[number];

export const SUPER_ADMIN_SETTINGS_DEFAULT_PATH = "/super-admin/settings/defaults";

export type SuperAdminSettingsNavItem = {
  readonly id: SuperAdminSettingsSectionId;
  readonly to: string;
  readonly labelKey: string;
  readonly icon: LucideIcon;
  readonly testId: string;
};

export const SUPER_ADMIN_SETTINGS_NAV: readonly SuperAdminSettingsNavItem[] = [
  {
    id: "defaults",
    to: SUPER_ADMIN_SETTINGS_DEFAULT_PATH,
    labelKey: "superAdmin.settings.defaultsTitle",
    icon: Building2,
    testId: "super-admin-settings-nav-defaults",
  },
  {
    id: "support",
    to: "/super-admin/settings/support",
    labelKey: "superAdmin.settings.supportTitle",
    icon: LifeBuoy,
    testId: "super-admin-settings-nav-support",
  },
  {
    id: "team",
    to: "/super-admin/settings/team",
    labelKey: "superAdmin.team.title",
    icon: ShieldCheck,
    testId: "super-admin-settings-nav-team",
  },
];

export function superAdminSettingsSection(pathname: string): SuperAdminSettingsSectionId | null {
  const item = SUPER_ADMIN_SETTINGS_NAV.find(
    (entry) => pathname === entry.to || pathname.startsWith(`${entry.to}/`),
  );
  return item?.id ?? null;
}
